<div class="current mb-2 p-1 sb-b body hub-custom-scrollbar" role="tabpanel" aria-hidden="true" style="max-height: 300px; overflow-y: auto; overflow-x: hidden;">
  @if (outcomeState.isReady && availableParents !== undefined) {
    <div class="row" [formGroup]="outcomeState.outcomeWizardForm">
      <div class="col-md-12" >
        @if (availableParents.length > 0) {
          <div>
            <div formGroupName="customOutcome">
              <mat-radio-group formControlName="parentCustomOutcomeId">
                <div class="mb-2">
                  <strong>Related Strategies and their Custom Outcomes</strong>
                </div>
                @for (availableParent of availableParents; track availableParent) {
                  <div>
                    <h4 [ngClass]="{'text-success': availableParent.strategyType === 'Primary Strategy', 'additional-strategy-text': availableParent.strategyType === 'Additional Strategy'}">
                      <strong>{{availableParent.strategyName}}</strong> ({{availableParent.strategyType}})
                      <span class="text-muted" style="font-size: 11pt;"> {{availableParent.relationshipType}}</span>
                    </h4>
                    @for (projectOutcome of availableParent.projectOutcomes; track projectOutcome) {
                      <label class="outcomes-radio-button">
                        <mat-radio-button color="primary" [value]="projectOutcome.customOutcome.customOutcomeId"
                          (change)="relatedCustomOutcomeSelected(projectOutcome, availableParent)">
                        </mat-radio-button>
                        <div class="radio-button-content">
                          <strong>{{projectOutcome.customOutcome.indicatorName}}</strong>
                          ({{projectOutcome.customOutcome.unit}})<br>
                          <span class="text-muted">{{projectOutcome.statement}}</span>
                        </div>
                      </label>
                    }
                  </div>
                }
              </mat-radio-group>
            </div>
            <span class="select-label text-info-800">Outcome Statement<app-help-selector
            selector="1069"></app-help-selector></span>
            <div >
              <textarea formControlName="statement" rows="3" cols="3"
                class="form-control record-description" appAutoFocus
              placeholder="Enter your outcome statement here..."></textarea>
            </div>
          </div>
        } @else {
          <div class="no-relations">
            You currently do not have any Related Strategies and/or your Related Strategies have
            no Custom Outcomes.
          </div>
        }
      </div>
    </div>
  }
</div>
